import React, { useEffect, useState } from "react";
import "./Login.scss";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";
import TwoSidePage from "../twoSidePage/TwoSidePage";
import { PreviousLocationState } from "../../../app/routes";
import useIsAuthenticated from "../../hooks/useIsAuthenticated";
import { ButtonType } from "../../../common";
import { Button } from "../../../common/button";
import useAuth from "../../../authProvider/hooks/useAuth";

const Login = () => {
  const { t, ready } = useTranslation("login");

  const { state, pathname } = useLocation();
  const locationState = state as PreviousLocationState | null;

  const { isAuthenticated, isLoading } = useIsAuthenticated();

  const { loginWithRedirect } = useAuth();

  const [previousPath, setPreviousPath] = useState("");

  // Not purely derived: the early returns make `previousPath` sticky — it keeps
  // the last non-"/login" path when locationState later has no previousPath (or
  // is "/login"). Deriving during render would reset it to "" in those cases and
  // change where the user lands after logging in.
  useEffect(() => {
    if (!locationState?.previousPath) {
      return;
    }

    if (locationState.previousPath !== "/login") {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- state is sticky, not derived; see above
      setPreviousPath(locationState.previousPath);
    }
  }, [locationState]);

  if (isAuthenticated) {
    return <Navigate to="/" state={{ previousPath: pathname }} />;
  }

  return (
    <TwoSidePage>
      <div className="login-page__container">
        <h3 className="welcome">{ready ? t("welcomeBack") : "Welcome Back"}</h3>
        <h2 className="login-to-account">
          {ready ? t("login") : "Log in to your account"}
        </h2>
        <Button
          handleClick={() => loginWithRedirect(previousPath)}
          className="sign-in-button"
          buttonType={ButtonType.Primary}
          text="Log in"
          htmlType="submit"
          disabled={isLoading}
          icon={<i className="bi bi-box-arrow-in-right sign-in-button__icon" />}
        />
      </div>
    </TwoSidePage>
  );
};

export default Login;
